export default "__VITE_ASSET__DRnw2JwH__"